import { productFamilyIdFormat } from "@redotech/redo-product-id";
import { referencedProductFamilySchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import * as z from "zod";

/**
 * The product families a knowledge article can cite. Serves both arms of the
 * reference picker: `query` searches the catalog, `productFamilyIds` hydrates
 * the families an article already references into the same shape.
 */
export const searchKnowledgeProductFamilies = {
  name: "searchKnowledgeProductFamilies" as const,
  input: z.object({
    /** Substring match on the title. Absent lists the catalog's first page. */
    query: z.string().optional(),
    /** Restrict to these families. An empty array selects nothing. */
    productFamilyIds: z.array(productFamilyIdFormat.schema).optional(),
    limit: z.number().int().positive().max(50).optional(),
  }),
  output: z.object({ families: z.array(referencedProductFamilySchema) }),
};
